var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIllustra2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 130,
    viewBox: "0 0 104 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3653 129.101L39.0742 121.865L49.1891 120.59L45.3653 129.101ZM46.8785 122.299L41.8666 122.93L44.9835 126.517L46.8785 122.299Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3104 52.3243L37.0494 1V52.3243H90.3104",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3104 52.3243H37.0494V1L23.9762 13.5892V65.3975H76.2686L90.3104 52.3243",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0492 52.3242L23.976 65.3974",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5067 52.5332L69.0742 65.1894",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6864 52.5332L61.2534 65.1894",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.97 52.5332L54.5374 65.1894",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7136 52.5332L47.2811 65.1894",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4331 52.5332L40.0006 65.1894",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6809 52.5332L31.2479 65.1894",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0492 45.8047L23.6167 58.4609",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.229 38.0488L23.796 50.7051",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0492 30.4824L23.6167 43.1382",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0492 22.9961L23.6167 35.6523",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0492 15.9844L23.6167 28.6406",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.229 7.17383L23.796 19.8301",
    stroke: "#108DA0",
    strokeWidth: 0.938124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6483 44.4712L67.9645 43.9731L65.9194 38.5765L60.7583 40.2257L61.0097 29.1465L51.764 37.3166L52.6956 38.3711L59.5298 32.3319L59.307 42.1672L65.0765 40.3233L66.6483 44.4712Z",
    fill: "#108DA0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0459 49.0693H-1.14441e-05V47.6621H22.0459V49.0693Z",
    fill: "#8F8F8F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7883 39.6889H-9.34601e-05V38.2812H10.7883V39.6889Z",
    fill: "#8F8F8F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9573 6.73836H55.007V6.02539H55.9573V6.73836ZM54.0561 6.73836H53.1058V6.02539H54.0561V6.73836ZM52.155 6.73836H51.2047V6.02539H52.155V6.73836ZM50.2535 6.73836H49.3031V6.02539H50.2535V6.73836ZM48.3523 6.73836H47.402V6.02539H48.3523V6.73836Z",
    fill: "#8F8F8F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8771 9.35165H45.5008V8.63867H47.8771V9.35165Z",
    fill: "#8F8F8F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6213 9.35165H50.2538V8.63867H57.6213V9.35165Z",
    fill: "#8F8F8F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9572 11.9649H47.1641V11.252H55.9572V11.9649Z",
    fill: "#8F8F8F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7145 104.96C21.6268 104.96 21.5415 104.992 21.4753 105.052C20.7792 105.683 19.9907 106.173 19.1328 106.51C17.5591 107.132 16.1032 107.081 15.128 106.916C15.6946 106.302 16.3475 105.33 16.5516 103.974C16.6642 103.258 16.6313 102.523 16.4531 101.789C16.439 101.731 16.4109 101.678 16.3715 101.634C14.4563 99.5102 13.4075 96.7727 13.4178 93.9255C13.4403 87.6331 18.5751 82.5311 24.8699 82.5545C27.9174 82.5653 30.7782 83.7633 32.9265 85.9266C35.0744 88.0899 36.2517 90.9597 36.2405 94.0067C36.239 94.4875 36.2071 94.9486 36.1462 95.3768C35.7737 98.4628 34.1123 101.298 31.5874 103.161C29.6154 104.612 27.279 105.378 24.8301 105.378H24.7883C23.7864 105.374 22.7835 105.238 21.8079 104.972C21.7769 104.964 21.7455 104.96 21.7145 104.96ZM16.4152 107.737C17.2933 107.737 18.3186 107.598 19.3942 107.173C20.2723 106.829 21.0842 106.337 21.808 105.71C22.785 105.959 23.7856 106.087 24.7856 106.09C27.4114 106.094 29.9026 105.285 32.0106 103.736C34.6931 101.755 36.4582 98.7426 36.8532 95.4704C36.9179 95.0168 36.9517 94.5234 36.9535 94.0097C36.9653 90.7723 35.7147 87.7234 33.4323 85.4245C31.1503 83.1256 28.1103 81.8535 24.8724 81.8418H24.8287C18.1624 81.8418 12.7284 87.252 12.7049 93.923C12.6941 96.9174 13.7856 99.797 15.7805 102.043C15.9184 102.657 15.941 103.269 15.8472 103.865C15.6037 105.485 14.5915 106.493 14.1674 106.851C14.0657 106.937 14.0206 107.072 14.0497 107.202C14.0793 107.332 14.1782 107.434 14.3068 107.468C14.795 107.597 15.5305 107.737 16.4152 107.737Z",
    fill: "#108DA0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6784 88.7965L23.1826 88.2923L18.8044 83.9141L18.3006 84.4178L22.6784 88.7965Z",
    fill: "#108DA0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3529 89.823L19.8572 89.3187L16.4701 85.9316L15.9658 86.4359L19.3529 89.823Z",
    fill: "#108DA0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5298 100.646L35.0336 100.142L32.7361 97.8438L32.2319 98.3485L34.5298 100.646Z",
    fill: "#108DA0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6054 104.971L30.1096 104.467L26.1151 100.473L25.6108 100.976L29.6054 104.971Z",
    fill: "#108DA0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3529 102.822L32.8572 102.318L28.3823 97.8438L27.8781 98.348L32.3529 102.822Z",
    fill: "#108DA0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.579 20.7656C102.431 20.7656 103.123 21.4589 103.123 22.3102C103.123 23.162 102.431 23.8553 101.579 23.8553C100.727 23.8553 100.034 23.162 100.034 22.3102C100.034 21.4589 100.727 20.7656 101.579 20.7656ZM101.579 24.5679C102.824 24.5679 103.836 23.5552 103.836 22.3103C103.836 21.0659 102.824 20.0527 101.579 20.0527C100.334 20.0527 99.3212 21.0659 99.3212 22.3103C99.3212 23.5552 100.334 24.5679 101.579 24.5679Z",
    fill: "#8F8F8F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIllustra2);
export default __webpack_public_path__ + "static/media/menu_illustra2.93a07242532dd5bea54f72c5f6c3b014.svg";
export { ForwardRef as ReactComponent };